<template>
  <div>
    <v-dialog
      v-model="activo"
      max-width="900"
    >
      <v-card
        flat
      >
        <v-card-title>
          <div v-if="!objetoNoVacio(retencion)">Agregar Ret. Especiales Factura {{ factura_id }}</div>
          <div v-else>Editar Ret. Especial Factura {{ factura_id }}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="activo = false"><v-icon title="Cerrar">fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row :no-gutters="$vuetify.breakpoint.xs">
            <v-col cols="12" sm="2" md="2" class="py-1">
              <v-text-field
                v-model="filtro.codigo"
                type="text"
                outlined
                dense
                hide-details
                label="Cod. Ret. Esp."
                @blur="completarRetencion(1)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="py-1">
              <v-autocomplete
                v-model="filtro.id"
                item-text="descripcion"
                item-value="id"
                :items="retenciones_especiales"
                hide-details
                outlined
                dense
                label="Retención"
                clearable
                @change="completarRetencion(2)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="py-1">
              <v-text-field
                v-model="filtro.tipo_retencion"
                type="text"
                outlined
                dense
                hide-details
                label="Tipo Ret. Esp."
                disabled
                readonly
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="py-1">
              <TextFieldMoney
                v-model="filtro.importe"
                label="Importe"
                v-bind:properties="{ prefix: '$', 'hide-details': boolString == 'true' }"
              />
            </v-col>
            <v-col cols="12" sm="1" md="1" class="py-1">
              <v-btn icon small color="success" v-if="!objetoNoVacio(retencion)" @click="setRetEspecial()" title="Agregar"><v-icon>fas fa-check</v-icon></v-btn>
              <v-btn icon small color="success" v-else @click="setRetEspecial()" title="Modificar"><v-icon>fas fa-check</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextFieldMoney from '../util/TextFieldMoney.vue'
import { objetoNoVacio, cadenaVacia } from '../../util/utils'
export default {
  props: {
    datos: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  components: {
    TextFieldMoney,
  },
  computed: {
    activo: {
      get(){
        return this.datos.activo
      },
      set(value){
        this.$emit('setearModalRetEsp', value)
      }
    },
    factura_id: {
      get(){
        return this.datos.factura_id
      }
    },
    retenciones_especiales: {
      get(){
        return this.datos.retenciones_especiales
      }
    },
    retencion: {
      get(){
        return this.datos.retencion
      }
    }
  },
  data() {
    return {
      filtro: {
        codigo: null,
        id: null,
        tipo_retencion: null,
        importe: null,
        descripcion: null,
        id_local: null
      },
      boolString: "true",
      objetoNoVacio: objetoNoVacio,
      impRef: 'impRef'
    }
  },
  methods: {
    initModal(){
      if (objetoNoVacio(this.retencion)){
        let existe = this.retenciones_especiales.filter(element => element.id == this.retencion.id)
        if (existe.length == 0){
          this.$store.dispatch('show_snackbar', {
            text: 'No se puede determinar la configuración de la Retención seleccionada.',
            color: 'warning',
          })
          this.activo = false
          return
        }
        this.filtro = {
          codigo: this.retencion.codigo,
          id: this.retencion.id,
          tipo_retencion: this.retencion.tipo,
          importe: this.retencion.importe,
          descripcion: this.retencion.descripcion,
          id_local: this.retencion.id_local
        }
      }
    },
    limpiarModal(){
      this.filtro = {
        codigo: null,
        id: null,
        tipo_retencion: null,
        importe: null,
        descripcion: null,
        id_local: null
      }
    },
    completarRetencion(opcion){
      let existe = []
      if (opcion == 1){
        // busco por codigo
        if (cadenaVacia(this.filtro.codigo)){
          this.limpiarModal()
          return
        }
        existe = this.retenciones_especiales.filter(element => element.codigo == this.filtro.codigo)
      }else{
        if (cadenaVacia(this.filtro.id)){
          this.limpiarModal()
          return
        }
        existe = this.retenciones_especiales.filter(element => element.id == this.filtro.id)
      }
      if (existe.length == 0) return
      this.filtro.codigo = existe[0].codigo
      this.filtro.id = existe[0].id
      this.filtro.tipo_retencion = existe[0].tipo
      this.filtro.descripcion = existe[0].descripcion
    },
    verificarObligatorios(){
      if (cadenaVacia(this.filtro.codigo)) return {valido: false, msj: 'Debe ingresar el Cód. de la Retención Especial.'}
      if (cadenaVacia(this.filtro.id)) return {valido: false, msj: 'Debe ingresar la Retención.'}
      if (cadenaVacia(this.filtro.importe) || this.filtro.importe == 0) return {valido: false, msj: 'Debe ingresar un Importe Válido.'}
      return {valido: true, msj: 'OK'}
    },
    setRetEspecial(){
      let control = this.verificarObligatorios()
      if (control.valido == false){
        this.$store.dispatch('show_snackbar', {
          text: control.msj,
          color: 'warning',
        })
        return
      }
      let respuesta = {}
      Object.assign(respuesta, this.filtro)
      respuesta.id_local = objetoNoVacio(this.retencion) ? this.retencion.id_local : null
      if (!objetoNoVacio(this.retencion)) this.$emit('setRetEsp', respuesta)
      else this.$emit('modRetEsp', respuesta)
      this.activo = false
    }
  },
  watch: {
    activo: function(){
      if (this.activo == false) this.limpiarModal()
      else this.initModal()
    }
  },
}
</script>

<style>

</style>